<template>
    <modal :show="show" v-on:update:show="handleModalClose">
        <template slot="header">
            <h5 class="modal-title">Buy a Number</h5>
        </template>

        <template>
            <form>
                <div class="row">
                    <div class="col">
                        <el-autocomplete
                                style="display:block;"
                                v-model="country"
                                :fetch-suggestions="querySearch"
                                placeholder="Search Countries"
                        >
                            <template slot-scope="{ item }">
                                <span class="link"> <span
                                        :class="'flag-icon flag-icon-' +  item.value.toLowerCase()"></span> <span
                                        class="pl-3">{{ item.name }}</span> <span
                                        class="pl-3 text-muted"> country code</span></span>
                            </template>
                        </el-autocomplete>
                    </div>
                </div>
                <hr>
                <div class="row">
                    <div class="col">
                        <span>Available numbers</span>

                        <table class="table table-hover">
                            <tbody>
                            <tr>
                                <td><span :class="'flag-icon flag-icon-' +  country.toLowerCase()"></span> <span
                                        class="pl-3">+32 3 227 227 5</span></td>
                                <td class="text-right">
                                    <base-button type="info" size="sm" class="right">Buy</base-button>
                                </td>
                            </tr>
                            <tr>
                                <td><span :class="'flag-icon flag-icon-' +  country.toLowerCase()"></span> <span
                                        class="pl-3">+32 3 227 227 5</span></td>
                                <td class="text-right">
                                    <base-button type="info" size="sm" class="right">Buy</base-button>
                                </td>
                            </tr>
                            <tr>
                                <td><span :class="'flag-icon flag-icon-' +  country.toLowerCase()"></span> <span
                                        class="pl-3">+32 3 227 227 5</span></td>
                                <td class="text-right">
                                    <base-button type="info" size="sm" class="right">Buy</base-button>
                                </td>
                            </tr>
                            </tbody>
                        </table>


                        <small slot="helperText" id="nameHelp" class="form-text text-muted">If you'd like a specific
                            number or need more help please contacts us by telephone or by email.
                        </small>
                    </div>
                </div>
            </form>
        </template>
    </modal>
</template>

<script>
    import Modal from "../../components/Modal";
    import countryDataJson from "country-region-data/data.json";

    export default {
        name: "BuyNumberModal",
        components: {
            Modal,
        },
        props: {
            show: Boolean,
        },
        data() {
            return {
                saving: false,
                country: 'BE',
                countryData: countryDataJson,
            }
        },
        computed: {}
        ,
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName)
            },
            querySearch(queryString, cb) {

                var results = queryString ? this.countryData.filter(this.createFilter(queryString)).map(s => {
                    let countryName = s.countryName;
                    return {name: countryName, value: s.countryShortCode}
                }) : $options.countryData.map(s => {
                    let name = s.countryName;
                    return {name: name, value: s.countryShortCode}
                });
                cb(results);
            },
            createFilter(queryString) {
                return (country) => {
                    return (country.countryName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            validate() {
                this.$validator.validateAll().then(isValid => {
                    if (isValid) {
                        this.updateSettings()
                    }
                })
            },
            handleModalClose(value) {
                this.$emit('update:show', value);
            },

        }
        ,
        mounted() {
        }
        ,
        watch: {}
        ,
    }
</script>

<style scoped>

</style>